<template>
<div class="p-0">
   <!--
        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
   <div  class="fp-onOff btn-info rounded"
   -->
   <div v-if="lbResume"
         class="lb-resume px-2 rounded-pill" 
         :style="{'background-color': label.backGroundColor}"
         :title="label.name + ' (' + label.id + ')'"
         >
      <!--
      <div class="lb-resume-into rounded-pill"
         :style="{'background-color': label.textColor}"
            >
      </div>
      -->
      <div v-if=" label.position == 'R' " class="bg-lb-resume-right rounded-pill"
         :style="{'background-color': label.textColor}">
      </div>
      <div v-if=" label.position == 'C' " class="bg-lb-resume-center rounded-pill"
         :style="{'background-color': label.textColor}">
      </div>
      <div v-if=" label.position == 'L' " class="bg-lb-resume-left rounded-pill"
         :style="{'background-color': label.textColor}">
      </div>
   </div>
   
   <div v-if="!lbResume" class="ps-2"
         :class="lbClass"
         :style="{'background-color': label.backGroundColor, 'color': label.textColor}"
         :title="'(' + label.id + ')'"
         >
      <div class="row">
         <div class="col-10 text-start">
            <b>{{label.name}}</b>
         </div>
         <div class="col-2">
            <font-awesome-icon v-if="viewAssigned && label.assigned" icon="check" />
         </div>
      </div>
   </div>
</div>
</template>

<script>
import { computed } from '@vue/reactivity'

export default {

   props: {
      label: {
         type: Object,
         required: true
      },
      format: {
         type: String,
         required: true
      },
      viewAssigned: {
         type: Boolean,
         default: false
      },
   },

   setup(props) {
      const lbClass = computed(() => {
         if (props.format == "filter")
            return "lb-filter btn-label rounded"
         if (props.format == "onOff")
            return "lb-onOff btn-label rounded"
         if (props.format == "label")
            return "bg-label text-center px-2 rounded"
      })
      const lbResume = computed(() => {
         if (props.format == "resume") {
            return true
         } else {
            return false
         }
      })

      return {
         lbClass, lbResume
      }
   }
}
</script>

<style scoped>
.lb-onOff {
  width: 333px;
  height: 26px;
}
.lb-filter {
  height: 26px;
}
.btn-label {
   opacity: .8;
}
.btn-label:hover {
   opacity: 1;
}
.lb-resume {
   width: 40px;
   height: 9px;
}
.lb-resume-into {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 16px;
}
/*height: 22px;l*/
.bg-label {
   width: min-content;
   height: auto;
   font-size: 13px;
}
.bg-lb-resume-left {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   right: 7px;
}
.bg-lb-resume-center {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 5px
}
.bg-lb-resume-right {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 16px
}
</style>